import { Dialog, Transition } from "@headlessui/react";
import moment from "moment";
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "react-lazy-load-image-component/src/effects/blur.css";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { useLocation } from "react-router-dom";
import PullToRefresh from "react-simple-pull-to-refresh";
import rewardIcon from "../../assets/images/icon_violation/reward.svg";
import { getViolationImage } from "../../core/service/api_violation_point";
import Config from "../../config/Config";

const ViolationPointRewardDetailMobile = (props: any) => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();
  const [preview, setPreview] = useState('')

  const getImage = async () => {
    try {
      const url = `${Config.BaseUrlViolationPointDev}student/image/get/thumb/${props.dataPoint.photoUrl}`;
      setPreview(url);
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  useEffect(() => {
    if (location.pathname.split("/")[2] != undefined) { }
  }, [location.pathname.split("/")[2]]);

  function closeModal() {
    setIsOpen(false);
  }

  const handleRefresh = async () => { };

  useEffect(() => {
    if (props.dataPoint.photoUrl) {
      console.log(props.dataPoint.photoUrl, 'lajshdahsd');
      getImage();
    }
  }, [props.dataPoint.photoUrl]);
  return (
    <>
      <div className="relative min-h-screen h-full  bg-psp-primary pb-10">
        <PullToRefresh className="text-center" onRefresh={handleRefresh}>
          <div className="text-left h-[95dvh]  px-4 py-6 bg-psp-primary top-to-bottom font-montserrat">
            <section className="mt-5 w-full h-full">
              <div className="flex flex-col justify-start h-full w-full">
                <div
                  className="bg-white p-3 rounded-xl flex-row flex gap-1 items-center flex-0 w-full justify-between mb-2"
                >
                  <div className="flex flex-col gap-1 w-[60%] ">
                    <div className="flex flex-row w-12 h-12 " >
                      {/* <img
                        className="w-full h-full object-cover rounded-full"
                      /> */}
                      <img
                        src={rewardIcon}
                        className="size-15 object-cover rounded-xl"
                      />
                    </div>
                    <div className="flex flex-col grow ">
                      <span className="font-montserrat text-xs font-medium text-psp-nav">
                        Detail Point Pelanggaran
                      </span>
                      {/* <span className="font-montserrat  font-medium text-psp-gray text-xs">
                        {studentSelected.classroomName}
                      </span> */}
                    </div>
                  </div>
                  <div className="flex flex-col w-[37%] items-center">
                    <span className="font-montserrat text-3xl font-bold text-[#FFBE0C]">
                      {props.dataPoint.rewardPoint}
                    </span>
                    <span className="font-montserrat font-medium text-psp-nav text-center text-sm">
                      Poin Reward
                    </span>
                  </div>
                </div>
                <div
                  className="bg-white p-3 rounded-xl flex-col flex gap-3 items-start flex-0 w-full justify-between"
                >
                  <div className="flex flex-col">
                    <div>
                      <label className="text-sm text-psp-gray control-Label required" htmlFor="pelanggaran">
                        Nama
                      </label>
                    </div>
                    <div>
                      {props.dataPoint.studentName}
                    </div>
                  </div>
                  <div className="flex flex-col">
                    <div>
                      <label className="text-sm text-psp-gray control-Label required" htmlFor="date">
                        Tanggal
                      </label>
                    </div>
                    <div>
                      {moment(props.dataPoint.rewardDate).format('DD MMMM YYYY')}
                    </div>
                  </div>
                  <div className="flex gap-1">
                    <div className="flex flex-col">
                      <div>
                        <label className="text-sm text-psp-gray control-Label required" htmlFor="pelanggaran">
                          Pelanggaran
                        </label>
                      </div>
                      <div>
                        {props.dataPoint.rewardName}
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col">
                    <div>
                      <label className="text-sm text-psp-gray control-Label" htmlFor="bukti">
                        Bukti
                      </label>
                    </div>
                    <div>
                      <img src={preview} alt="Bukti" className="img-fluid rounded-3 size-20" />
                    </div>
                  </div>
                  <div className="flex flex-col">
                    <div>
                      <label className="text-sm text-psp-gray control-Label " htmlFor="description">
                        Keterangan
                      </label>
                    </div>
                    <div>
                      {props.dataPoint.description}
                    </div>
                  </div>
                  <div className="flex justify-end">
                  </div>
                </div>
              </div>
            </section>
          </div>
        </PullToRefresh>
      </div>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-2 text-center w-full">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-psp-primary p-2 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    <div className="flex flex-row">
                      Pilih
                    </div>
                  </Dialog.Title>
                  <div className="rounded-2xl bg-psp-primary mt-3 p-2 flex flex-col gap-2">

                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default ViolationPointRewardDetailMobile;
